import { useEffect, useState } from "react";
import api from "../lib/api";
import { logError } from "../lib/logError";
import { Megaphone, Warning, X } from "@phosphor-icons/react";

const STYLE = {
  info: "border-sky-300 bg-sky-50 text-sky-900",
  warning: "border-amber-300 bg-amber-50 text-amber-900",
  critical: "border-red-400 bg-red-50 text-red-900",
};
const ICON = { info: Megaphone, warning: Warning, critical: Warning };
const DISMISS_KEY = "claroshield.announce.dismissed";

const readDismissed = () => {
  try { return JSON.parse(localStorage.getItem(DISMISS_KEY) || "[]"); }
  catch (e) { logError("announce dismiss read", e); return []; }
};

export function AnnouncementsBanner() {
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(readDismissed);

  useEffect(() => {
    api.get("/announcements/active")
      .then((r) => setItems(r.data.announcements || []))
      .catch((e) => logError("announcements load", e));
  }, []);

  const dismiss = (id) => {
    const next = Array.from(new Set([...dismissed, id]));
    setDismissed(next);
    try { localStorage.setItem(DISMISS_KEY, JSON.stringify(next)); }
    catch (e) { logError("announce dismiss persist", e); }
  };

  const visible = items.filter((a) => !dismissed.includes(a.id));
  if (visible.length === 0) return null;

  return (
    <div className="space-y-3" data-testid="announcements-banner">
      {visible.map((a) => {
        const Icon = ICON[a.level] || Megaphone;
        return (
          <div key={a.id} data-testid={`announcement-${a.id}`}
            className={`flex items-start gap-3 border ${STYLE[a.level] || STYLE.info} px-5 py-3`}>
            <Icon size={20} weight="fill" className="mt-0.5 shrink-0" />
            <div className="flex-1 min-w-0">
              {a.title && <div className="font-display font-bold text-sm" data-testid={`announcement-title-${a.id}`}>{a.title}</div>}
              <div className="text-sm leading-snug whitespace-pre-wrap" data-testid={`announcement-message-${a.id}`}>{a.message}</div>
            </div>
            <button data-testid={`announcement-dismiss-${a.id}`} onClick={() => dismiss(a.id)}
              className="shrink-0 opacity-60 hover:opacity-100 transition-opacity" aria-label="Dismiss">
              <X size={16} weight="bold" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
